import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LearnsetService } from 'src/app/core/learnset.service';
import { Learnset } from 'src/app/models/learnset.model';
import { TopicStructure } from 'src/app/models/topic-structure.model';
import { Location } from '@angular/common';
import { DemoService } from 'src/app/core/demo.service';
import { FlashcardService } from 'src/app/core/flashcard.service';

@Component({
  selector: 'app-create-ai-flashcards',
  templateUrl: './create-ai-flashcards.component.html',
  styleUrls: ['./create-ai-flashcards.component.scss'],
  standalone: false
})
export class CreateAiFlashcardsComponent {

  isDemo?: boolean;
  demoLog?: any;

  step: number = 0;
  titles: string[] = ['Was möchtest du Lernen?', 'Wähle aus, welche Unterthemen du lernen möchtest', 'Deine Lernkarten wurden erstellt'];
  infoTexts: string[] = ['learnset.create_steps.prompt_step.info', 'learnset.create_steps.review_step.info', 'learnset.create_steps.edit_step.info'];
  nextButtonTexts: string[] = ['learnset.create_steps.prompt_step.next_text', 'learnset.create_steps.review_step.next_text', 'Alle übernehmen'];

  isLoading: boolean = false;
  topicStructure?: TopicStructure | null;
  changedTopicStructure?: TopicStructure;
  learnset?: Learnset | null;

  courseId?: number;
  isSaving: boolean = false;

  promptForm?: FormGroup;

  errorMessage: string = '';

  uploadedFiles?: File[];

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private learnsetService: LearnsetService,
    private demoService: DemoService,
    private flashcardService: FlashcardService
  ) {}

  ngOnInit() {
    this.isDemo = this.router.url === '/demo';
    this.promptForm = this.fb.group({
      prompt: ['', []],
      learncardsRange: ['10-20', [Validators.required]]
    });
    this.promptForm.get('prompt')?.valueChanges.subscribe(() => {
      this.topicStructure = null;
      // this.learnset = null;
    });
    this.promptForm.get('learncardsRange')?.valueChanges.subscribe(() => {
      // this.learnset = null;
    });
    
    this.route.queryParams.subscribe(params => {
      const courseId = params['courseId'];
      if (courseId) {
        this.courseId = courseId;
      }
    });

    if (this.isDemo) {
      this.demoService.addDemoLog(false, false).subscribe((demoLog) => {
        this.demoLog = demoLog;
      });
    } else {
      this.learnsetService.getLearnset(this.route.snapshot.paramMap.get('id')!).subscribe((learnset) => {this.learnset = Learnset.constructLearnset(learnset)});
    }
  }

  nextStep() {
    if (this.step === 0) {
      if (!this.topicStructure) {
        this.generateStructure();
      } else {
        this.step = this.step + 1;
      }
      return;
    }
    if (this.step === 1) {
      if (this.learnset) {
        this.generateFlashcards();
      } else {
        this.step = this.step + 1;
      }
      return;
    }
    if (this.step === 2 && this.learnset?.name && this.learnset.name.length > 1) {
      this.saveFlashcards();
    }
  }

  prevStep() {
    this.step = this.step > 0 ? this.step - 1 : this.step;
  }

  handleCardsCountChange(event: string) {
    // this.learnset = null;
  }

  handlePromptChange(event: string) {
    this.topicStructure = null;
    // this.learnset = null;
  }

  handleTopicStructureChange(event: any) {
    this.topicStructure = event;
    // this.learnset = null;
  }

  generateStructure() {
    this.promptForm!.markAllAsTouched();
    if (!this.promptForm!.valid || (this.promptForm?.value['prompt'].length === 0 && !this.uploadedFiles)) {
      return;
    }
    if (this.isDemo) {
      this.demoLog.step1Finished = true;
      this.demoLog.prompt = this.promptForm!.value.prompt;
      this.demoService.updateDemoLog(this.demoLog).subscribe((data) => {
        this.demoLog = data;
      });
    }
    this.isLoading = true;
    this.learnsetService.generateStructure(this.promptForm!.value.prompt, this.uploadedFiles!).subscribe((result: any) => {
      this.topicStructure = TopicStructure.constructTopicStructure(result);
      this.isLoading = false;
      this.step = this.step + 1;
    }, () => {
      this.isLoading = false;
      this.errorMessage = 'Die Dateien dürfen insgesamt nicht größer als 4.5MB sein.';
    });
  }

  generateFlashcards() {
    if (this.isDemo) {
      this.demoLog.step2Finished = true;
      this.demoService.updateDemoLog(this.demoLog).subscribe((data) => {
        this.demoLog = data;
      });
    }
    this.isLoading = true;
    this.learnsetService.generateLearnset(this.promptForm!.value.prompt, this.topicStructure!, this.promptForm!.value.learncardsRange).subscribe((result: any) => {
      this.isLoading = false;
      result.courseId = this.courseId;
      this.learnset!.flashcards = Learnset.constructLearnset(result).flashcards;
      this.step = this.step + 1;
    }, () => {
      this.isLoading = false;
      this.errorMessage = 'Es ist ein Fehler aufgetreten. Bitte nochmal versuchen.';
    });
  }

  saveFlashcards() {
    this.isLoading = true;
    this.learnset?.flashcards.forEach(flashcard => flashcard.learnset_id = this.learnset!.id);
    this.flashcardService.saveFlashcards(this.learnset!.flashcards, 'ai-assistant').subscribe((result: any) => {
      this.router.navigate([`/sets/${this.learnset!.id}`]);
      this.isLoading = false;
    }, () => {
      this.isLoading = false;
      this.errorMessage = 'Beim Speichern ist ein Fehler aufgetreten. Bitte versuche es nochmal.';
    });
  }

  leaveDemo() {
    this.location.back();
  }

  onFileReceived(files: any): void {
    this.uploadedFiles = files;
  }
}
